import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MotifButton, MotifTextLink, MotifIcon } from '@ey-xd/motif-react';
import { useRecoilValue } from 'recoil';
import { Current_User, Recoil_Selected_Account_State } from '@recoil/recoil';
import { actionIcLaunch24px } from '@ey-xd/motif-react/assets/icons';
import { subHeaderGCSPPastQtrDetails, subHeaderGCSPPastMonthDetails } from '@services/gcspServices';
import {
  SubHeaderContainer,
  SubmitButtonContainer,
  Hyperlink,
  QuarterTitle,
  HyperlinkText,
  Divider,
} from '@atoms/subHeaderText/subHeader.styles';
import { BUTTON_TITLE } from '@constants/commonConstants';
import { structureMonth } from '@util/commonUtil';
import { logError } from '@util/commonFunctions';

const PastSubHeaderGcsp = props => {
  const navigate = useNavigate();
  //Below Line direct-import-and-test-needed
  const [subHeaderData, setSubHeaderData] = useState([]); // eslint-disable-line
  const selectedAccount = useRecoilValue(Recoil_Selected_Account_State);
  const currentUser = useRecoilValue(Current_User);

  const MONTH = props.month;
  const YEAR = props.year;
  const forecast_type = props.forecast_type;
  const QUARTER = props.quarter;
  const fetchDateRange = async () => {
    try {
      const data = await (forecast_type === 'quarter'
        ? subHeaderGCSPPastQtrDetails(QUARTER, YEAR, currentUser.email)
        : subHeaderGCSPPastMonthDetails(QUARTER, MONTH, YEAR, currentUser.email));
      setSubHeaderData(data);
    } catch (error) {
      logError('fetchDateRange', error);
    }
  };

  useEffect(() => {
    fetchDateRange();
  }, [forecast_type, MONTH, YEAR, QUARTER, currentUser]);

  // const formatDate = date => {
  //   const month_array = ABBREVIATED_MONTH_LIST;
  //   const d = new Date(date);
  //   const day = d.getDate();
  //   const month = month_array[d.getMonth()];
  //   const year = d.getFullYear();
  //   return `${month} ${day}, ${year}`;
  // };

  // let start_date;
  // let end_date;
  // if (subHeaderData.length !== 0) {
  // const keys = Object.keys(subHeaderData);
  // start_date = subHeaderData[keys[0]].start_date;
  // end_date = subHeaderData[keys[keys.length - 1]].end_date;
  // start_date = formatDate(start_date);
  // end_date = formatDate(end_date);
  // }

  const fullMonth = MONTH ? structureMonth(MONTH) : '';
  const quarter = QUARTER.charAt(1);

  const renderQuarterInfo = () => {
    if (setSubHeaderData.length !== 0) {
      return (
        <QuarterTitle>
          {forecast_type === 'quarter'
            ? `Quarter ${quarter} FY ${YEAR}`
            : `${fullMonth} FY ${YEAR}`}
        </QuarterTitle>
      );
    }
  };

  const onHyperlinkClick = () => {
    if (
      localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') != 'null'
    ) {
      // Set flag to use userEmail for GCSP hyperlink operations(CRM and LENS) in super user mode
      // Allow navigation and not prevent it with userEmail for Super User
      localStorage.setItem('isGcspHyperlinkOperation', 'true');
    } else {
      // Regular user operation
      localStorage.setItem('isGcspHyperlinkOperation', 'false');
    }
  };

  return (
    <SubHeaderContainer>
      {renderQuarterInfo()}
      <SubmitButtonContainer>
        <Hyperlink>
          <MotifTextLink
            variant="alt"
            href={
              selectedAccount
                ? `${process.env.REACT_APP_ACCOUNT_LENS_URL}app/dashboard/pipeline/${selectedAccount.ey_dunsnumber}`
                : null
            }
            target="_blank"
            onClick={e => {
              onHyperlinkClick(e, 'LENS');
            }}
          >
            <MotifIcon src={actionIcLaunch24px} />
            <HyperlinkText>View Account in LENS</HyperlinkText>
          </MotifTextLink>
        </Hyperlink>
        <Hyperlink>
          <MotifTextLink
            variant="alt"
            href={
              selectedAccount
                ? `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&forceUCI=1&pagetype=entityrecord&etn=account&id=${selectedAccount.account_id}`
                : null
            }
            target="_blank"
            onClick={e => {
              onHyperlinkClick(e, 'CRM');
            }}
          >
            <MotifIcon src={actionIcLaunch24px} />
            <HyperlinkText>View Opportunites in EY CRM</HyperlinkText>
          </MotifTextLink>
        </Hyperlink>

        <Divider />
        <MotifButton
          variant="secondary"
          className="submitButton"
          onClick={() => {
            navigate('/');
          }}
        >
          {BUTTON_TITLE.CLOSE}
        </MotifButton>
      </SubmitButtonContainer>
    </SubHeaderContainer>
  );
};

export default PastSubHeaderGcsp;
